export const fullMonthYear = 'DDD'
export const fullMonthYearWeekDay = 'DDDD'
export const ISODateFormat = 'yyyy-MM-dd'
